import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=049cc428&lang=pug&"
import script from "./Models.vue?vue&type=script&lang=js&"
export * from "./Models.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports